class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    
    // Fetch full cart data to show all items
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        this.renderAllCartItems(cart);
      });
    
    this.getSectionsToRender().forEach((section) => {
      if (section.id !== 'cart-notification-product') {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  renderAllCartItems(cart) {
    const productContainer = document.getElementById('cart-notification-product');
    let html = '<div style="max-height: 300px; overflow-y: auto;">';
    
    cart.items.forEach((item, index) => {
      html += `
        <div style="display: flex; gap: 1rem; padding: 1rem; ${index !== cart.items.length - 1 ? 'border-bottom: 1px solid #e0e0e0;' : ''}">
          <img src="${item.image}" alt="${item.product_title}" style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; flex-shrink: 0;">
          <div style="flex: 1; min-width: 0;">
            <h3 style="margin: 0 0 0.5rem 0; font-size: 0.95em; font-weight: 600; color: #000;">${item.product_title}</h3>
            ${item.variant_title ? `<p style="margin: 0 0 0.5rem 0; font-size: 0.85em; color: #666;">${item.variant_title}</p>` : ''}
            <p style="margin: 0; font-size: 0.9em; color: #000;">
              <strong>Menge: ${item.quantity}</strong> × ${(item.price / 100).toFixed(2)} €
            </p>
          </div>
          <div style="text-align: right; flex-shrink: 0;">
            <p style="margin: 0; font-size: 1em; font-weight: 600; color: #000;">${((item.quantity * item.price) / 100).toFixed(2)} €</p>
          </div>
        </div>
      `;
    });
    
    html += '</div>';
    productContainer.innerHTML = html;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

